import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';


const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    minWidth: 120,
  }
}));

export default function DialogSelect() {
  const classes = useStyles();
  const [state, setState] = React.useState({
    open: false,
    age: '',
  });

  const handleChange = name => event => {
    setState({ ...state, [name]: Number(event.target.value) });
  };

  function handleClickOpen() {
    setState({ ...state, open: true });
  }

  function handleClose() {
    setState({ ...state, open: false });
  }


  return (
    <React.Fragment >
      <Button style={{"position":"absolute","left":"10%"}}  color="primary" variant="contained" onClick={handleClickOpen}>Table Filter</Button>
      <Dialog disableBackdropClick disableEscapeKeyDown open={state.open} onClose={handleClose}>
        <DialogTitle>Enter Filters</DialogTitle>
        <DialogContent>
          <form className={classes.container}>
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="age-native-simple">Table Status</InputLabel>
              <Select
                native
                value={state.status}
                onChange={handleChange('status')}
                input={<Input id="age-native-simple" />}
              >
                <MenuItem value="">
                  <em>No filter</em>
                </MenuItem>
                <option value={0}>No Filter</option>
                <option value={1}>Reserved</option>
                <option value={2}>Available</option>
                <option value={3}>Occupied</option>
                <option value={4}>Cleaning</option>
              </Select>
            </FormControl>
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="age-native-simple">Table Seats</InputLabel>
              <Select
                native
                value={state.seats}
                onChange={handleChange('seats')}
                input={<Input id="age-native-simple" />}
              >
                <option value={0}>No Filter</option>
                <option value={10}>1-2</option>
                <option value={20}>4</option>
                <option value={30}>6</option>
                <option value={40}>8</option>
              </Select>
            </FormControl>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleClose} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>


    </React.Fragment>
  );

  
}